// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { DealershipService } from '@services/dealership.service';
import { DocumentsService } from '@services/documents.service';
import { SuccessModalService } from '@services/success-modal.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DealAndDocResolver } from './services/resolvers/deal-and-doc-resolver';
import { DealModule } from './pddj/deal/deal.module';
import { DealsModule } from './pddj/deals/deals.module';
import { LandingPageComponent } from './login/landingpage/landing-page.component';
import { AuthService } from './login/services/auth.service';
import { LoginModule } from './login/login.module';
import { MaterialModule } from './shared/material.module';
import { ModalsModule } from './modals/modals.module';
import { PddjModule } from './pddj/pddj.module';
import { SharedModule } from './shared/shared.module';
import { ThemeDirective } from './directives/theme.directive';
import { NewUserModule } from './new-user/new-user.module';
import { SystemDocumentComponent } from './login/system-document/system-document.component';
import { BuyerDashboardModule } from './buyer-dashboard/buyer-dashboard.module';
import { DealerDashboardModule } from './dealer-dashboard/dealer-dashboard.module';
import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';
import { SystemDocsToSignGuard } from '@services/route-guards/system-docs-to-sign.guard';
import { SystemDocsPageGuard } from '@services/route-guards/system-docs-page.guard';
import { PendingChangesGuard } from '@services/route-guards/pending-changes.guard';
import { VersionNumberResolver } from '@services/resolvers/version-number.resolver';
import { SsoModule } from './sso/sso.module';
import { UploadModule } from './doc-upload/upload.module';
import { SelfEnrollmentModule } from './login/self-enrollment/self-enrollment.module';
import { AgreementsComponent } from './agreements/agreements.component';
import { RemoveAriaOwnsDirective } from './remove-aria-owns.directive';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    declarations: [AppComponent, LandingPageComponent, SystemDocumentComponent, AgreementsComponent, ThemeDirective, RemoveAriaOwnsDirective],
    imports: [
        AppRoutingModule,
        BuyerDashboardModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        DealerDashboardModule,
        DealModule,
        DealsModule,
        HttpClientModule,
        LoginModule,
        MaterialModule,
        ModalsModule,
        NewUserModule,
        PddjModule,
        SharedModule,
        UploadModule,
        SelfEnrollmentModule,
        SsoModule,
        MatSnackBarModule,
    ],
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        AuthService,
        DealAndDocResolver,
        DatePipe,
        DealershipService,
        SuccessModalService,
        SystemDocsToSignGuard,
        SystemDocsPageGuard,
        PendingChangesGuard,
        VersionNumberResolver,
    ],
    bootstrap: [AppComponent],
    exports: [LandingPageComponent, SharedModule],
})
export class AppModule {
    constructor(private readonly documentsService: DocumentsService) {}
}
